import {useForm} from "@mantine/form";
import {
    FormCargoInformationFormValues,
    formCargoInformationInitialValues
} from "./Form.cargo.information.types";
import {
    Button,
    Checkbox,
    Grid,
    Group,
    NumberInput,
    Select,
    Stack,
    Textarea,
    TextInput,
    Title,
    Text, Divider
} from "@mantine/core";
import {ArrowRight} from "tabler-icons-react";
import React from "react";
import {DatePicker} from "@mantine/dates";

interface Props {
    onSubmit?: (values: any) => void
    buttons?: any,
    initialValues?: any,
}

function CargoInformation({onSubmit, buttons, initialValues}: Props) {

    const form = useForm({
        initialValues: initialValues || formCargoInformationInitialValues,
        validate: (values) => {
            let containerValObj = validateContainerSizes(values);
            return ({
                ...containerValObj
            })
        }
    });

    function validateContainerSizes(values: any) {
        let hasAtLeastOne = false;
        const containerSizes = [
            FormCargoInformationFormValues.containerCount20,
            FormCargoInformationFormValues.containerCount40,
            FormCargoInformationFormValues.containerCount40HQ,
            FormCargoInformationFormValues.containerCount45,
        ]

        containerSizes.forEach(cs => {
            if (values[cs] !== 0) {
                hasAtLeastOne = true;
            }
        })

        if (!hasAtLeastOne) {
            return {
                [FormCargoInformationFormValues.containerCount20]: "At least one must be greater than 0.",
                [FormCargoInformationFormValues.containerCount40]: "At least one must be greater than 0.",
                [FormCargoInformationFormValues.containerCount40HQ]: "At least one must be greater than 0.",
                [FormCargoInformationFormValues.containerCount45]: "At least one must be greater than 0."
            };
        } else {
            return {}
        }
    }

    function handleSubmit(values: any) {
        if (onSubmit) {
            onSubmit(values)
        }
    }

    function renderButtons() {
        if (buttons) {
            return buttons;
        } else {
            return (
                <Group position="right" mt="xl" align="flex-end">
                    <Button color="blue" type="submit" rightIcon={<ArrowRight/>}>
                        Next
                    </Button>
                </Group>
            )
        }
    }

    return (
        <form onSubmit={form.onSubmit(handleSubmit)}>
            <Stack>
                <Title order={3}>Cargo Information</Title>
                <Divider/>
                <Grid>
                    <Grid.Col md={12}>
                        <Textarea
                            required
                            placeholder="Commodity"
                            label="Commodity"
                            {...form.getInputProps(FormCargoInformationFormValues.commodity)}
                        />
                    </Grid.Col>
                    <Grid.Col md={12}>
                        <Textarea
                            placeholder="Special Instructions"
                            label="Special Instructions"
                            {...form.getInputProps(FormCargoInformationFormValues.specialInstructions)}
                        />
                    </Grid.Col>
                    <Grid.Col md={12}>
                        <DatePicker
                            required
                            placeholder="Cargo Ready Date"
                            label="Cargo Ready Date"
                            {...form.getInputProps(FormCargoInformationFormValues.cargoReadyDate)}
                        />
                    </Grid.Col>
                    <Grid.Col md={12}>
                        <TextInput
                            required
                            placeholder="PO #"
                            label="PO #"
                            {...form.getInputProps(FormCargoInformationFormValues.po)}
                        />
                    </Grid.Col>
                    <Grid.Col md={12}>
                        <Select
                            data={[
                                {value: "FCL", label: "FCL"},
                                {value: "LCL", label: "LCL"},
                                {value: "53`", label: "53`"},
                                {value: "LTL", label: "LTL"},
                            ]}
                            required
                            placeholder="Container Usage Type"
                            label="Container Usage Type"
                            {...form.getInputProps(FormCargoInformationFormValues.containerUsageType)}
                        />
                    </Grid.Col>

                    <Grid.Col md={12}>
                        <Grid>
                            <Grid.Col span={12} style={{paddingBottom: 0, marginTop: 6}}>
                                <Text size="sm">Container Sizes</Text>
                                <Text color="gray" size="xs">At least one of the container sizes must be greater than
                                    0.</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <NumberInput
                                    label="Size 20'"
                                    {...form.getInputProps(FormCargoInformationFormValues.containerCount20)}
                                />
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <NumberInput
                                    placeholder="Container"
                                    label="Size 40'"
                                    {...form.getInputProps(FormCargoInformationFormValues.containerCount40)}
                                />
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <NumberInput
                                    placeholder="Container"
                                    label="Size 40'HQ"
                                    {...form.getInputProps(FormCargoInformationFormValues.containerCount40HQ)}
                                />
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <NumberInput
                                    placeholder="Container"
                                    label="Size 45'"
                                    {...form.getInputProps(FormCargoInformationFormValues.containerCount45)}
                                />
                            </Grid.Col>
                        </Grid>
                    </Grid.Col>
                    <Grid.Col md={6}>
                        <Checkbox
                            label="Will Provide ISF Form"
                            {...form.getInputProps(FormCargoInformationFormValues.willProvideISFForm, {type: "checkbox"})}
                        />
                    </Grid.Col>
                    <Grid.Col md={6}>
                        <Checkbox
                            label="Will Provide Documents"
                            {...form.getInputProps(FormCargoInformationFormValues.willProvideDocuments, {type: "checkbox"})}
                        />
                    </Grid.Col>
                </Grid>
                {renderButtons()}
            </Stack>
        </form>
    )

}

export default CargoInformation;